import {scanCopy} from '../../lib/customerCopyGuard.js'
import {unresolvedTokens} from './draftTokens.js'

// All manual exits consume this same result for the actual edited text.
export function reviewCopyBoundary(draft,body,askable){
 const text=`${draft?.subject||''}\n${draft?.greeting||''}\n${body||''}`
 const findings=scanCopy(text,{identityNames:draft?.identityNames||[]})
 const signature=draft?.senderSignature
 const signatureMatches=!!signature&&String(body||'').trimEnd().endsWith(signature)
 const blocked=askable!==true||draft?.available!==true||!String(body||'').trim()||unresolvedTokens(text).length>0||findings.length>0||!signatureMatches
 return {blocked,findings,signatureMatches}
}
